import axios from 'axios'
import Axios from 'axios'
const state = {}
const getters = {}
const actions = {
  async getIndustryMenu ({ state, commit }, { request = axios.get, id, type }) {
    let res = await request('/general/industry', { id, type })
    return res.data
  },
  async getIndustryDetails ({ state, commit }, { request = axios.get, user_id, type }) {
    let res = await request('/general/account', { user_id, type })
    return res.data
  },
  async getQualification ({ state, commit }, { request = axios.get, id, type }) {
    let res = await request('/general/qualification', { id, type })
    return res.data
  },
  async getIndustryAgencyDetails ({ state, commit }, { request = axios.get }) {
    let res = await request('/general/agency-qualification')
    return res.data
  },
  async submitIndustry ({ state, commit }, { request = axios.post, userid, params, type }) {
    let res = await request('/general/account/' + userid, { ...params, type })
    return res
  },
  async getVerify ({ state, commit }, { request = axios.post, params, type }) {
    let res = await request('/general/account/verify', { ...params, type })
    return res.data
  },
  async deleteIndustry ({ state, commit }, { request = axios.post, id, type }) {
    let res = await request('/general/account/' + id)
    return res
  }
}
const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}
